import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type SessionModel = {
  id: string | number
}

export const createNewSession = () => {
  return new ServicesUseCase('/sessao', makeAxiosHttpClient())
}

export const fetchListToSession = (id?: number) => {
  return new ServicesUseCase(
    `/sessao/getSessaoAndServico/${id}`,
    makeAxiosHttpClient()
  )
}
export const getByIdSession = (id: string) => {
  return new ServicesUseCase(`/sessao/getSessao/${id}`, makeAxiosHttpClient())
}

export const updateSession = () => {
  return new ServicesUseCase(`/sessao/updateSessao`, makeAxiosHttpClient())
}

export const deleteSession = ({ id }: SessionModel) => {
  return new ServicesUseCase(
    `/sessao/deleteSessao/${id}`,
    makeAxiosHttpClient()
  )
}
